import packageJson from '../../package.json'
import { useLocale } from '../shared/i18n/LocaleContext'

export function AppFooter({ standalone = false }: { standalone?: boolean }) {
  const { t } = useLocale()
  const text = t('app.footer').replace('{version}', packageJson.version)

  return <footer className={`app-footer${standalone ? ' standalone' : ''}`}>{text}</footer>
}
